module.exports = __webpack_public_path__ + "static/img/omskvodokanal.a6dbc74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/omskvodokanal.png
// module id = n2aq
// module chunks = 0